import PageContainer from 'components/PageContainer';
import PageHeading from 'components/PageHeading';
import Spinner from 'components/Spinner';
import useAuthStore from 'store/authStore';

function LoadingPage() {
  const { token } = useAuthStore();
  let status = 'Loading page';
  if (!token) {
    status = 'Authenticating';
  }
  return (
    <PageContainer>
      <PageHeading>Loading</PageHeading>

      <div className="inline-flex flex-col items-center justify-center rounded-md bg-white p-5 shadow-card">
        <div className="pb-3">
          <Spinner />
        </div>
        <div>{status}</div>
      </div>
    </PageContainer>
  );
}

export default LoadingPage;
